import { render, staticRenderFns } from "./statisticsFieldListEditor.vue?vue&type=template&id=a0510720&scoped=true"
import script from "./statisticsFieldListEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./statisticsFieldListEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./statisticsFieldListEditor.vue?vue&type=style&index=0&id=a0510720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0510720",
  null
  
)

export default component.exports